import Modal from 'react-modal';
import axios from 'axios';
import "./css/contactForm.css";
import { useLocation } from 'react-router-dom';
import parse from "url-parse";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import PhoneInput from 'react-phone-number-input'
import { toast, ToastContainer } from 'react-toastify';
import { useState, useEffect } from 'react';
Modal.setAppElement('#modal-root'); // set the root element for the modal


const ContactForm = (props) => {

  let name = props.name;
  let email = props.email;
  let phone = props.phone;
  let setName = props.setName;
  let setEmail = props.setEmail;
  let setPhone = props.setPhone;
  // Auto-show modal
  let showModal = true;
  let setShowModal = props.setShowModal;
  
  // Note: Blur effect is now managed in audit.js using inline styles
  // on the content wrapper div - no need to manipulate DOM directly here
  let contactExpert = props.contactExpert;
  let setContactExpert = props.setContactExpert;
  let contactFormSuccessMessage = props.contactFormSuccessMessage;
  let setContactFormSuccessMessage = props.setContactFormSuccessMessage;
  let audit_url = props.url;

  // Add state for email validation and IP address
  const [emailValidationStatus, setEmailValidationStatus] = useState("");
  const [emailValidationMessage, setEmailValidationMessage] = useState("");
  const [ipAddress, setIpAddress] = useState("");

//   let url = 'https://vir16qej5k.execute-api.us-east-1.amazonaws.com/production/lead-update-contact';
  let url = 'https://api.thecommerceshop.com/lead-update-contact';
  // Get report ID from the current URL
  const location = useLocation();
  const parsed = parse(location.search, true);
  const report_id = parsed.pathname.split("/").pop();

  // Fetch IP address on component mount
  useEffect(() => {
    const fetchIpAddress = async () => {
      try {
        const response = await axios.get('https://api.ipify.org?format=json');
        setIpAddress(response.data.ip);
      } catch (error) {
        console.error('Error fetching IP address:', error);
        // Set a default IP if fetch fails
        setIpAddress('127.0.0.1');
      }
    };
    
    fetchIpAddress();
  }, []);

  // Function to validate email with external API
  const validateEmailWithAPI = async (emailToValidate) => {
    console.log('Validating email:', emailToValidate);
    try {
      const response = await axios({
        method: 'POST',
        url: 'https://narefute.thecommerceshop.com/api/user/',
        headers: {
          'Accept': '*/*',
          'Authorization': 'Token ad447970d4ca820d09c4883b71c8caa9fce4b1eb',
          'Content-Type': 'application/json'
        },
        data: {
          email: emailToValidate,
          ip_address: ipAddress,
          url: 'https://www.conversionbox.ai/'
        },
        // Set a reasonable timeout to prevent long waits if API is down
        timeout: 5000
      });
      
      // Success - HTTP 200 means VALID_EMAIL or ANTISPAM_SYSTEM
      const status = response.data.status;
      console.log('Email validation succeeded:', response.data);
      setEmailValidationStatus(status);
      setEmailValidationMessage("");
      document.getElementById('email-validation').innerText = "";
      return true;
      
    } catch (error) {
      console.error('Error validating email:', error);
      console.log('Error response data:', error.response?.data);
      console.log('Error status:', error.response?.status);
      
      // Check if it's a 419 status (invalid email)
      if (error.response && error.response.status === 419) {
        const status = error.response.data.status;
        setEmailValidationStatus(status);
        
        // Set appropriate validation message based on status
        let message = "";
        switch(status) {
          case 'INVALID_EMAIL':
            message = "Invalid email address. Please check and try again.";
            break;
          case 'MALICIOUS_EMAIL':
            message = "This email appears to be malicious. Please use a different email.";
            break;
          case 'INVALID_DOMAIN':
            message = "The email domain is invalid. Please use a valid domain.";
            break;
          default:
            message = "Invalid email address. Please check and try again.";
        }
        
        // Ensure message is displayed both in state and DOM
        setEmailValidationMessage(message);
        document.getElementById('email-validation').innerText = message;
        return false;
      }
      
      // For API unreachable, network errors, timeouts, etc. - skip validation and allow form submission
      console.log('Email validation API unreachable, skipping validation');
      // Don't explicitly set validation status - just leave it as is
      setEmailValidationMessage("");
      document.getElementById('email-validation').innerText = "";
      return true;
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    
    // Check if all required fields are filled
    if (!name || !email || !phone) {
      return false;
    }
    
    // Basic format validation
    if (!validateEmailFormat(email) || isRestrictedDomain(email)) {
      let mainDomain = extractDomain(audit_url);
      document.getElementById('email-validation').innerText = 'Enter a valid business email. e.g. john@'+mainDomain;
      return false;
    }
    
    // Clear previous validation messages
    document.getElementById('email-validation').innerText = '';
    
    // ALWAYS validate email on form submission, regardless of blur events
    // Check if email validation has already been performed
    if (emailValidationStatus === "") {
      // Email hasn't been validated yet, validate it now
      props.setButtonText('Validating...');
      
      const isEmailValid = await validateEmailWithAPI(email);
      
      if (!isEmailValid) {
        document.getElementById('email-validation').innerText = emailValidationMessage;
        props.setButtonText('View Full Report');
        return false;
      }
    } else {
      // Email has been validated, check if it's valid
      if (!isButtonEnabled) {
        // Email is invalid, don't proceed
        document.getElementById('email-validation').innerText = emailValidationMessage;
        props.setButtonText('View Full Report');
        return false;
      }
    }
    
    // Proceed with form submission if email is valid
    props.setButtonText('Submitting...');
    let loader = {loader:true};
    props.setContactFormSuccessMessage({...contactFormSuccessMessage,...loader});
    if(typeof phone === 'undefined')
      phone = '';
    axios({
        method: 'post',
        url: url,
        data: {
          name: name,
          email: email,
          phone: phone,
          contact_expert: contactExpert,
          unique_report_id: report_id
        }
    }).then(function (response) {
        // Clear the form after submission
        setName('');
        setEmail('');
        setPhone('');
        setContactExpert(true);
        setShowModal(false);
        
        // Set isShowRecommendations to false which will trigger the useEffect to remove blur
        props.setIsShowRecommendations(false);
        
        // Force remove blur directly from all possible elements using !important
        document.getElementById('root').style.cssText += ';filter: none !important; -webkit-filter: none !important;';
        
        // Remove blur from content div in audit.js
        const contentDiv = document.querySelector('#' + props.device + ' > div:last-child');
        if (contentDiv) {
          contentDiv.style.cssText += ';filter: none !important; -webkit-filter: none !important;';
        }
        
        // Add a style tag to ensure no blur anywhere with max specificity
        let styleTag = document.getElementById('no-blur-style');
        if (!styleTag) {
          styleTag = document.createElement('style');
          styleTag.id = 'no-blur-style';
          styleTag.innerHTML = `
            #root, #root *, #${props.device}, #${props.device} > div:last-child {
              filter: none !important;
              -webkit-filter: none !important;
            }
          `;
          document.head.appendChild(styleTag);
        }
        
        // Log that blur should be removed
        console.log('Form submitted - blur should be removed');
        toast.success('Thanks for sharing the information!', {
        position: "top-right",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        });
      })
      .catch(function (error) {
        setContactFormSuccessMessage('Something went wrong.');
        props.setButtonText('View Full Report');
    });

  };

  const handleNameChange = (event) => {
    setName(event.target.value);
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
    // Reset validation status when email changes
    document.getElementById('email-validation').innerText = '';
    setEmailValidationStatus("");
    setEmailValidationMessage("");
  };

  // Add handler for email field focus
  const handleEmailFocus = () => {
    // Clear validation messages when user clicks in the field
    document.getElementById('email-validation').innerText = '';
    setEmailValidationStatus("");
    setEmailValidationMessage("");
  };

  // Handle email field blur (when user clicks outside)
  const handleEmailBlur = async (event) => {
    // Skip validation if input is empty
    if (!email) return;
    
    // Basic format validation
    if (!validateEmailFormat(email) || isRestrictedDomain(email)) {
      let mainDomain = extractDomain(audit_url);
      const message = 'Enter a valid business email. e.g. john@'+mainDomain;
      document.getElementById('email-validation').innerText = message;
      setEmailValidationMessage(message);
      return;
    }
    
    // Clear previous validation messages
    document.getElementById('email-validation').innerText = '';
    setEmailValidationMessage("");
    
    try {
      // Set loading state
      props.setButtonText('Validating...');
      
      // Validate email with API
      await validateEmailWithAPI(email);
    } catch (error) {
      // If any unexpected error occurs during validation, just continue with form submission
      console.error('Unexpected error during validation:', error);
      // Skip validation without setting status
      setEmailValidationMessage("");
      document.getElementById('email-validation').innerText = "";
    } finally {
      // Reset button text
      props.setButtonText('View Full Report');
    }
  };

  const handleCheckboxChange = (event) => {
    setContactExpert((event.target.checked) ? 1 : 0);
  };

  const handlePhoneChange = (event) => {
    setPhone(event.target.value);
  };

  // Prevent the form from toggling when clicking outside
  const toggleModal = () => {
    // No longer toggle the modal when called
    // This prevents closing when called by the overlay click
  };

  // Determine if button should be enabled based on email validation status
  const isButtonEnabled = emailValidationStatus === "VALID_EMAIL" || emailValidationStatus === "ANTISPAM_SYSTEM" || emailValidationStatus === "";

  useEffect(() => {
    if (emailValidationMessage) {
      document.getElementById('email-validation').innerText = emailValidationMessage;
    }
  }, [emailValidationMessage]);

  return (
    <div className="showmore-container">
      {/* Removed Show Full Report button - form displays immediately */}
      <Modal
        isOpen={showModal}
        onRequestClose={toggleModal}
        contentLabel="Contact Form"
        className="Modal"
        overlayClassName="Overlay"
        shouldCloseOnOverlayClick={false}
      >
        <div>
            <span className="contact-title"><b>Your Comprehensive Website<br/> Performance Report is Ready</b></span>
            <p className="contact-content">Fill in the details below and access the full report along with a step-by-step action plan to boost your site performance
            </p>
        </div>
        <div>
            <form id="contact-expert" onSubmit={handleSubmit}>
            {/* Name field  */}
            <label>
                <input className="cinput" type="text" maxlength="32" value={name} onChange={handleNameChange} pattern="[a-zA-Z][a-zA-Z ]+" title="Enter alphabets only." placeholder="Enter your name*" required/>
                <span id="name-validation"></span>
            </label>
            {/* Only email field visible */}
            <label>
                <input 
                  className="cinput" 
                  type="email" 
                  id="email" 
                  value={email} 
                  onChange={handleEmailChange} 
                  onFocus={handleEmailFocus}
                  onBlur={handleEmailBlur}
                  placeholder="Enter your business email address*" 
                  required
                />
                <span id="email-validation" className={emailValidationMessage ? "validation-error" : ""}></span>
            </label>            
            {/* Phone field */}
            <label>
            <PhoneInput
              defaultCountry="US"
              className="cinput"
              placeholder="Enter phone number*"
              value={phone}
              onChange={setPhone}
              required/>
            </label>
            <div className="showmorebutton">
             <button 
               className="contact-button" 
               type="submit" 
               disabled={emailValidationStatus !== "" && !isButtonEnabled}
               style={{
                 opacity: (emailValidationStatus !== "" && !isButtonEnabled) ? 0.6 : 1,
                 filter: (emailValidationStatus !== "" && !isButtonEnabled) ? 'blur(1px)' : 'none'
               }}
             >
               <b>{props.buttonText}</b>
               { contactFormSuccessMessage.loader &&
                  <img style={{display:"inline-block"}} src="/img/loader-pulse.gif" width="25" height="25"/>
               }
             </button>
            </div>
            <div className="msg-contact">
                { contactFormSuccessMessage.error ?
                    <p>{contactFormSuccessMessage.msg}</p> : <p></p>
                }
                { contactFormSuccessMessage.success ?
                    <p>{contactFormSuccessMessage.msg}</p> : <p></p>
                }
            </div>
            </form>
        </div>
        
      </Modal>
    </div>
  );
};

function validateEmailFormat(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

function isRestrictedDomain(email) {
  const restrictedDomains = ['gmail.com', 'yahoo.com', 'hotmail.com'];
  const domain = email.split('@')[1];
  return restrictedDomains.includes(domain);
}

function validateNameFormat(name) {
  const nameRegex = /^[a-zA-Z]+(?:\s[a-zA-Z]+)*$/;
  return nameRegex.test(name) && !name.startsWith(' ');
}

function extractDomain(url) {
  // Remove protocol (e.g., 'http://', 'https://')
  let domain = url.replace(/(^\w+:|^)\/\//, '');

  // Remove path
  domain = domain.split('/')[0];

  // Extract main domain
  const domainParts = domain.split('.');
  const mainDomain = domainParts.slice(-2).join('.');

  return mainDomain;
}

export default ContactForm;